//react
import { useServices } from "../../Providers/Services";

//form
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

//components
import Input from "../Input";
import { Container } from "./styles";
import Button from "../Button";

//interfaces
import { IServiceAPI } from "../../Interfaces";
import { userID } from "../../Services/api";

interface IServiceForm {
  title: string;
  price: string;
}

interface IServiceProps {
  handleForm: (data: IServiceAPI, id?: number) => void;
  buttonName: string;
  service?: { currentTitle: string; currentPrice: number; id?: number };
  handleModal: () => void;
}
export const RegisterServiceForm = ({
  service = { currentTitle: "", currentPrice: 0, id: 0 },
  handleForm,
  buttonName,
  handleModal,
}: IServiceProps) => {
  const { currentPrice, currentTitle, id } = service;

  const { getServices } = useServices();

  const formSchema = yup.object().shape({
    title: yup.string().required("Nome obrigatório"),
    price: yup
      .string()
      .required("Preço obrigatório")
      .matches(/^\d+$/, "Apenas números"),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<IServiceForm>({
    resolver: yupResolver(formSchema),
    defaultValues: {
      title: currentTitle,
      price: currentPrice ? currentPrice.toString() : "",
    },
  });

  const onSubmit = (data: IServiceForm): void => {
    const { title, price } = data;
    const priceNumber = Number(price);
    handleForm({ title: title, price: priceNumber, idAdm: userID, id: id });
    handleModal();
    getServices();
  };

  return (
    <Container>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Input
          className="titleInput"
          label="Nome"
          name="title"
          register={register}
          placeholder="Nome"
        />
        {!!errors.title && <p className="error">{errors.title.message}</p>}
        <Input
          className="priceInput"
          label="Preço"
          name="price"
          register={register}
          placeholder="Preço"
        />
        {!!errors.price && <p className="error">{errors.price.message}</p>}
        <Button className="submit">{buttonName}</Button>
      </form>
    </Container>
  );
};
